import { render, staticRenderFns } from "./TicketTypes.vue?vue&type=template&id=42531e2f&scoped=true"
import script from "./TicketTypes.vue?vue&type=script&lang=js"
export * from "./TicketTypes.vue?vue&type=script&lang=js"
import style0 from "./TicketTypes.vue?vue&type=style&index=0&id=42531e2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42531e2f",
  null
  
)

export default component.exports